var map = {
	"./descend-1.mp4": "b174",
	"./descend-2.png": "771e",
	"./descend-3.png": "e4ac",
	"./ip-1.mp4": "e333",
	"./ip-2.png": "72f1",
	"./ip-3.png": "9732",
	"./ip-4.png": "ce6a",
	"./metaverse-1.mp4": "0ae1",
	"./metaverse-2.mp4": "9750",
	"./metaverse-3.png": "564b",
	"./squishiland-1.mp4": "987f",
	"./squishiland-2.png": "cc17",
	"./squishiland-3.png": "c568"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a58e";